// src/pages/Signup.jsx
import React, { useState } from "react";
import {
  FaUser,
  FaEnvelope,
  FaLock,
  FaPhone,
  FaEye,
  FaEyeSlash
} from "react-icons/fa";
import { auth, db } from "../firebase";
import {
  createUserWithEmailAndPassword,
  updateProfile
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { track } from "@vercel/analytics"; // ✅ Vercel Analytics
import "./Signup.css";

import SocialSidebar from "../components/SocialSideBar";

const Signup = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [className, setClassName] = useState("");
  const [preparingFor, setPreparingFor] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [termsError, setTermsError] = useState(false);

  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!agreedToTerms) {
      setTermsError(true);
      return;
    }
    setTermsError(false);

    // ✅ Track email/password signup attempt
    track("signup_email_submit", { page: window.location.pathname, email });

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await updateProfile(user, { displayName: username });

      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        username,
        email,
        mobile,
        phoneNumber: user.phoneNumber || "",
        class: className,
        preparingFor,
        address: "",
        authMethod: "password",
        photoURL: user.photoURL || "",
        isAdmin: false,
        isSuperAdmin: false,
        dashboardAccess: { userManagement: false, dashboard: false, invoices: false },
        purchasedCourses: [],
        testsTaken: [],
        role: "student",
        createdAt: new Date().toISOString(),
      });

      await user.sendEmailVerification();
      alert("Signup successful! A verification link has been sent to your email.");
      navigate("/login");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="signup-container">
      <SocialSidebar />
      <div className="signup-box">
        <h2>One Step Closer to Your Potential</h2>
        <h1 className="brand-name">PrrepX Pathshala</h1>

        <form onSubmit={handleSignup}>
            <div className="input-group">
              <FaUser className="icon" />
              <input
                type="text"
                placeholder="Full Name"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <FaPhone className="icon" />
              <input
                type="tel"
                placeholder="Mobile Number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <select
                value={className}
                onChange={(e) => setClassName(e.target.value)}
                required
                className="custom-select"
              >
                <option value="" disabled hidden>Select Your Class</option>
                <option value="6">Class 6</option>
                <option value="7">Class 7</option>
                <option value="8">Class 8</option>
                <option value="9">Class 9</option>
                <option value="10">Class 10</option>
                <option value="11">Class 11</option>
                <option value="12">Class 12</option>
                <option value="Dropper">Dropper</option>
              </select>
            </div>
            <div className="input-group">
              <select
                value={preparingFor}
                onChange={(e) => setPreparingFor(e.target.value)}
                required
                className="custom-select"
              >
                <option value="" disabled hidden>Exam Preparing For</option>
                <option value="School">School</option>
                <option value="Boards">Boards</option>
                <option value="JEE">JEE</option>
                <option value="NEET">NEET</option>
              </select>
            </div>
            <div className="input-group">
              <FaEnvelope className="icon" />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="input-group password-group">
              <FaLock className="icon" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className="input-group password-group">
              <FaLock className="icon" />
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <span className="eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <label className={`terms-check-inline${termsError ? " terms-check-error" : ""}`}>
              <input
                type="checkbox"
                checked={agreedToTerms}
                onChange={(e) => { setAgreedToTerms(e.target.checked); setTermsError(false); }}
              />
              <span>
                {termsError && <span className="terms-required">* </span>}
                I agree to the{" "}
                <a href="/terms-conditions" target="_blank" rel="noreferrer">Terms &amp; Conditions</a>
                {" "}and{" "}
                <a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
              </span>
            </label>
            <button type="submit" className="signup-btn">Sign Up</button>
          </form>

        <p className="login-text">
          Already have an account? <a href="/login">Login</a>
        </p>
      </div>
    </div>
  );
};

export default Signup;
